
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as search5Zt6kjw_45lY2jAKeqUWYNJwwaZ8UQSFLlBePn3QB_45oN4Meta } from "/usr/src/app/src/pages/search.vue?macro=true";
import { default as _91_46_46_46all_93fmlnCEB17POHMZUL8Dx_oM0zmdDbbp_45aQa1POv3NslcMeta } from "/usr/src/app/src/pages/[...all].vue?macro=true";
import { default as carttHbhSR_45YOc14YGbTBrKd4N_45dAVOOUfCSe_Qr6208d8gMeta } from "/usr/src/app/src/pages/shop/cart.vue?macro=true";
import { default as index0GVhztlKb2OOTWVG5C0aY31UODIloXLGfi4sVoUA0rsMeta } from "/usr/src/app/src/pages/shop/index.vue?macro=true";
import { default as login2ypkuOXlSrLvEnvUaLQ39fRbQeX9av5smRCMMNqQnS4Meta } from "/usr/src/app/src/pages/shop/login.vue?macro=true";
import { default as healthcheckNwF3qUnbj3lWAhZ07G9iSrhbEt43V_srt3o6FFpv9bEMeta } from "/usr/src/app/src/pages/healthcheck.vue?macro=true";
import { default as searchHP7XyyS5u6PkZcSrGiB3BbS9iZlspSOEgpggHZi6iUEMeta } from "/usr/src/app/src/pages/shop/search.vue?macro=true";
import { default as registerIFFuNaY0ZVNENyIUqnJGTBugLV9HDTtk3Erdi9Mw3ycMeta } from "/usr/src/app/src/pages/shop/register.vue?macro=true";
import { default as _91_46_46_46slug_93Ea3yJlJOj_45L3i__45NhBp3eISLXKBruYStpTLEo6UPz4oMeta } from "/usr/src/app/src/pages/shop/[...slug].vue?macro=true";
import { default as _91_46_46_46id_93v3Nxiyhkmg84SAZalEfGOm3TjI06F4HYHW5UHVrfUFcMeta } from "/usr/src/app/src/pages/preview/[...id].vue?macro=true";
import { default as indexdqOezqvq9TDDVMksnq_R6sR7_45AhCFsNb1AcP6Q6e2LsMeta } from "/usr/src/app/src/pages/shop/account/index.vue?macro=true";
import { default as indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta } from "/usr/src/app/src/pages/shop/checkout/index.vue?macro=true";
import { default as paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_45y7_459S4Meta } from "/usr/src/app/src/pages/shop/account/payment.vue?macro=true";
import { default as profile5e3p3MrvXGeZ_45BshUskUMBExy3jLYQwUTOrVsWox1xMMeta } from "/usr/src/app/src/pages/shop/account/profile.vue?macro=true";
import { default as recoveryAeY_W4RVe0ENr7tF_45NzztaDZQ9Ul8B3H4JXS0sBA7hsMeta } from "/usr/src/app/src/pages/shop/account/recovery.vue?macro=true";
import { default as addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta } from "/usr/src/app/src/pages/shop/account/addresses.vue?macro=true";
import { default as passwordvFWSA2QQdzx0LV044rYXMLZAqPtFba8a1yYOFA41gp8Meta } from "/usr/src/app/src/pages/account/recover/password.vue?macro=true";
import { default as _91id_93E746u_HXrcsZbiI_ku6ilgxKdToUnh2pmWI6SHdV6nAMeta } from "/usr/src/app/src/pages/registration/module/[id].vue?macro=true";
import { default as index63NT8U0qypjm8fQ_45lUIsablB_45bxZAy6tyWFvsUi0z_IMeta } from "/usr/src/app/src/pages/shop/account/orders/index.vue?macro=true";
import { default as _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta } from "/usr/src/app/src/pages/shop/account/orders/[...id].vue?macro=true";
import { default as _91id_93HAcsnstXPJNxSmBnPQxvdogBmwIX27d6dt6gXO52VF0Meta } from "/usr/src/app/src/pages/registration/conference/[id].vue?macro=true";
import { default as _91_46_46_46all_932nJ6nzQTaPv7OHSrgJoROtb6CF3U41YUuN_gUZrm6OsMeta } from "/usr/src/app/src/pages/registration/seminar/[...all].vue?macro=true";
import { default as indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta } from "/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue?macro=true";
export default [
  {
    name: "search___de",
    path: "/search",
    component: () => import("/usr/src/app/src/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/usr/src/app/src/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/usr/src/app/src/pages/search.vue")
  },
  {
    name: "search___it",
    path: "/it/search",
    component: () => import("/usr/src/app/src/pages/search.vue")
  },
  {
    name: "all___de",
    path: "/:all(.*)*",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/[...all].vue")
  },
  {
    name: "all___en",
    path: "/en/:all(.*)*",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/[...all].vue")
  },
  {
    name: "all___fr",
    path: "/fr/:all(.*)*",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/[...all].vue")
  },
  {
    name: "all___it",
    path: "/it/:all(.*)*",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/[...all].vue")
  },
  {
    name: "shop-cart___de",
    path: "/shop/cart",
    component: () => import("/usr/src/app/src/pages/shop/cart.vue")
  },
  {
    name: "shop-cart___en",
    path: "/en/shop/cart",
    component: () => import("/usr/src/app/src/pages/shop/cart.vue")
  },
  {
    name: "shop-cart___fr",
    path: "/fr/shop/cart",
    component: () => import("/usr/src/app/src/pages/shop/cart.vue")
  },
  {
    name: "shop-cart___it",
    path: "/it/shop/cart",
    component: () => import("/usr/src/app/src/pages/shop/cart.vue")
  },
  {
    name: "shop___de",
    path: "/shop",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/shop/index.vue")
  },
  {
    name: "shop___en",
    path: "/en/shop",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/shop/index.vue")
  },
  {
    name: "shop___fr",
    path: "/fr/shop",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/shop/index.vue")
  },
  {
    name: "shop___it",
    path: "/it/shop",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/shop/index.vue")
  },
  {
    name: "shop-login___de",
    path: "/shop/login",
    component: () => import("/usr/src/app/src/pages/shop/login.vue")
  },
  {
    name: "shop-login___en",
    path: "/en/shop/login",
    component: () => import("/usr/src/app/src/pages/shop/login.vue")
  },
  {
    name: "shop-login___fr",
    path: "/fr/shop/login",
    component: () => import("/usr/src/app/src/pages/shop/login.vue")
  },
  {
    name: "shop-login___it",
    path: "/it/shop/login",
    component: () => import("/usr/src/app/src/pages/shop/login.vue")
  },
  {
    name: "healthcheck___de",
    path: "/healthcheck",
    component: () => import("/usr/src/app/src/pages/healthcheck.vue")
  },
  {
    name: "healthcheck___en",
    path: "/en/healthcheck",
    component: () => import("/usr/src/app/src/pages/healthcheck.vue")
  },
  {
    name: "healthcheck___fr",
    path: "/fr/healthcheck",
    component: () => import("/usr/src/app/src/pages/healthcheck.vue")
  },
  {
    name: "healthcheck___it",
    path: "/it/healthcheck",
    component: () => import("/usr/src/app/src/pages/healthcheck.vue")
  },
  {
    name: "shop-search___de",
    path: "/shop/search",
    component: () => import("/usr/src/app/src/pages/shop/search.vue")
  },
  {
    name: "shop-search___en",
    path: "/en/shop/search",
    component: () => import("/usr/src/app/src/pages/shop/search.vue")
  },
  {
    name: "shop-search___fr",
    path: "/fr/shop/search",
    component: () => import("/usr/src/app/src/pages/shop/search.vue")
  },
  {
    name: "shop-search___it",
    path: "/it/shop/search",
    component: () => import("/usr/src/app/src/pages/shop/search.vue")
  },
  {
    name: "shop-register___de",
    path: "/shop/register",
    component: () => import("/usr/src/app/src/pages/shop/register.vue")
  },
  {
    name: "shop-register___en",
    path: "/en/shop/register",
    component: () => import("/usr/src/app/src/pages/shop/register.vue")
  },
  {
    name: "shop-register___fr",
    path: "/fr/shop/register",
    component: () => import("/usr/src/app/src/pages/shop/register.vue")
  },
  {
    name: "shop-register___it",
    path: "/it/shop/register",
    component: () => import("/usr/src/app/src/pages/shop/register.vue")
  },
  {
    name: "shop-slug___de",
    path: "/shop/:slug(.*)*",
    component: () => import("/usr/src/app/src/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___en",
    path: "/en/shop/:slug(.*)*",
    component: () => import("/usr/src/app/src/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___fr",
    path: "/fr/shop/:slug(.*)*",
    component: () => import("/usr/src/app/src/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___it",
    path: "/it/shop/:slug(.*)*",
    component: () => import("/usr/src/app/src/pages/shop/[...slug].vue")
  },
  {
    name: "preview-id___de",
    path: "/preview/:id(.*)*",
    component: () => import("/usr/src/app/src/pages/preview/[...id].vue")
  },
  {
    name: "preview-id___en",
    path: "/en/preview/:id(.*)*",
    component: () => import("/usr/src/app/src/pages/preview/[...id].vue")
  },
  {
    name: "preview-id___fr",
    path: "/fr/preview/:id(.*)*",
    component: () => import("/usr/src/app/src/pages/preview/[...id].vue")
  },
  {
    name: "preview-id___it",
    path: "/it/preview/:id(.*)*",
    component: () => import("/usr/src/app/src/pages/preview/[...id].vue")
  },
  {
    name: "shop-account___de",
    path: "/shop/account",
    meta: indexdqOezqvq9TDDVMksnq_R6sR7_45AhCFsNb1AcP6Q6e2LsMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/index.vue")
  },
  {
    name: "shop-account___en",
    path: "/en/shop/account",
    meta: indexdqOezqvq9TDDVMksnq_R6sR7_45AhCFsNb1AcP6Q6e2LsMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/index.vue")
  },
  {
    name: "shop-account___fr",
    path: "/fr/shop/account",
    meta: indexdqOezqvq9TDDVMksnq_R6sR7_45AhCFsNb1AcP6Q6e2LsMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/index.vue")
  },
  {
    name: "shop-account___it",
    path: "/it/shop/account",
    meta: indexdqOezqvq9TDDVMksnq_R6sR7_45AhCFsNb1AcP6Q6e2LsMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/index.vue")
  },
  {
    name: "shop-checkout___de",
    path: "/shop/checkout",
    meta: indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/index.vue")
  },
  {
    name: "shop-checkout___en",
    path: "/en/shop/checkout",
    meta: indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/index.vue")
  },
  {
    name: "shop-checkout___fr",
    path: "/fr/shop/checkout",
    meta: indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/index.vue")
  },
  {
    name: "shop-checkout___it",
    path: "/it/shop/checkout",
    meta: indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/index.vue")
  },
  {
    name: "shop-account-payment___de",
    path: "/shop/account/payment",
    meta: paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_45y7_459S4Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/payment.vue")
  },
  {
    name: "shop-account-payment___en",
    path: "/en/shop/account/payment",
    meta: paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_45y7_459S4Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/payment.vue")
  },
  {
    name: "shop-account-payment___fr",
    path: "/fr/shop/account/payment",
    meta: paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_45y7_459S4Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/payment.vue")
  },
  {
    name: "shop-account-payment___it",
    path: "/it/shop/account/payment",
    meta: paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_45y7_459S4Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/payment.vue")
  },
  {
    name: "shop-account-profile___de",
    path: "/shop/account/profile",
    meta: profile5e3p3MrvXGeZ_45BshUskUMBExy3jLYQwUTOrVsWox1xMMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/profile.vue")
  },
  {
    name: "shop-account-profile___en",
    path: "/en/shop/account/profile",
    meta: profile5e3p3MrvXGeZ_45BshUskUMBExy3jLYQwUTOrVsWox1xMMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/profile.vue")
  },
  {
    name: "shop-account-profile___fr",
    path: "/fr/shop/account/profile",
    meta: profile5e3p3MrvXGeZ_45BshUskUMBExy3jLYQwUTOrVsWox1xMMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/profile.vue")
  },
  {
    name: "shop-account-profile___it",
    path: "/it/shop/account/profile",
    meta: profile5e3p3MrvXGeZ_45BshUskUMBExy3jLYQwUTOrVsWox1xMMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/profile.vue")
  },
  {
    name: "shop-account-recovery___de",
    path: "/shop/account/recovery",
    component: () => import("/usr/src/app/src/pages/shop/account/recovery.vue")
  },
  {
    name: "shop-account-recovery___en",
    path: "/en/shop/account/recovery",
    component: () => import("/usr/src/app/src/pages/shop/account/recovery.vue")
  },
  {
    name: "shop-account-recovery___fr",
    path: "/fr/shop/account/recovery",
    component: () => import("/usr/src/app/src/pages/shop/account/recovery.vue")
  },
  {
    name: "shop-account-recovery___it",
    path: "/it/shop/account/recovery",
    component: () => import("/usr/src/app/src/pages/shop/account/recovery.vue")
  },
  {
    name: "shop-account-addresses___de",
    path: "/shop/account/addresses",
    meta: addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/addresses.vue")
  },
  {
    name: "shop-account-addresses___en",
    path: "/en/shop/account/addresses",
    meta: addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/addresses.vue")
  },
  {
    name: "shop-account-addresses___fr",
    path: "/fr/shop/account/addresses",
    meta: addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/addresses.vue")
  },
  {
    name: "shop-account-addresses___it",
    path: "/it/shop/account/addresses",
    meta: addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/addresses.vue")
  },
  {
    name: "account-recover-password___de",
    path: "/account/recover/password",
    component: () => import("/usr/src/app/src/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___en",
    path: "/en/account/recover/password",
    component: () => import("/usr/src/app/src/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___fr",
    path: "/fr/account/recover/password",
    component: () => import("/usr/src/app/src/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___it",
    path: "/it/account/recover/password",
    component: () => import("/usr/src/app/src/pages/account/recover/password.vue")
  },
  {
    name: "registration-module-id___de",
    path: "/registration/module/:id()",
    component: () => import("/usr/src/app/src/pages/registration/module/[id].vue")
  },
  {
    name: "registration-module-id___en",
    path: "/en/registration/module/:id()",
    component: () => import("/usr/src/app/src/pages/registration/module/[id].vue")
  },
  {
    name: "registration-module-id___fr",
    path: "/fr/registration/module/:id()",
    component: () => import("/usr/src/app/src/pages/registration/module/[id].vue")
  },
  {
    name: "registration-module-id___it",
    path: "/it/registration/module/:id()",
    component: () => import("/usr/src/app/src/pages/registration/module/[id].vue")
  },
  {
    name: "shop-account-orders___de",
    path: "/shop/account/orders",
    meta: index63NT8U0qypjm8fQ_45lUIsablB_45bxZAy6tyWFvsUi0z_IMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/index.vue")
  },
  {
    name: "shop-account-orders___en",
    path: "/en/shop/account/orders",
    meta: index63NT8U0qypjm8fQ_45lUIsablB_45bxZAy6tyWFvsUi0z_IMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/index.vue")
  },
  {
    name: "shop-account-orders___fr",
    path: "/fr/shop/account/orders",
    meta: index63NT8U0qypjm8fQ_45lUIsablB_45bxZAy6tyWFvsUi0z_IMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/index.vue")
  },
  {
    name: "shop-account-orders___it",
    path: "/it/shop/account/orders",
    meta: index63NT8U0qypjm8fQ_45lUIsablB_45bxZAy6tyWFvsUi0z_IMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/index.vue")
  },
  {
    name: "shop-account-orders-id___de",
    path: "/shop/account/orders/:id(.*)*",
    meta: _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/[...id].vue")
  },
  {
    name: "shop-account-orders-id___en",
    path: "/en/shop/account/orders/:id(.*)*",
    meta: _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/[...id].vue")
  },
  {
    name: "shop-account-orders-id___fr",
    path: "/fr/shop/account/orders/:id(.*)*",
    meta: _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/[...id].vue")
  },
  {
    name: "shop-account-orders-id___it",
    path: "/it/shop/account/orders/:id(.*)*",
    meta: _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/[...id].vue")
  },
  {
    name: "registration-conference-id___de",
    path: "/registration/conference/:id()",
    component: () => import("/usr/src/app/src/pages/registration/conference/[id].vue")
  },
  {
    name: "registration-conference-id___en",
    path: "/en/registration/conference/:id()",
    component: () => import("/usr/src/app/src/pages/registration/conference/[id].vue")
  },
  {
    name: "registration-conference-id___fr",
    path: "/fr/registration/conference/:id()",
    component: () => import("/usr/src/app/src/pages/registration/conference/[id].vue")
  },
  {
    name: "registration-conference-id___it",
    path: "/it/registration/conference/:id()",
    component: () => import("/usr/src/app/src/pages/registration/conference/[id].vue")
  },
  {
    name: "registration-seminar-all___de",
    path: "/registration/seminar/:all(.*)*",
    component: () => import("/usr/src/app/src/pages/registration/seminar/[...all].vue")
  },
  {
    name: "registration-seminar-all___en",
    path: "/en/registration/seminar/:all(.*)*",
    component: () => import("/usr/src/app/src/pages/registration/seminar/[...all].vue")
  },
  {
    name: "registration-seminar-all___fr",
    path: "/fr/registration/seminar/:all(.*)*",
    component: () => import("/usr/src/app/src/pages/registration/seminar/[...all].vue")
  },
  {
    name: "registration-seminar-all___it",
    path: "/it/registration/seminar/:all(.*)*",
    component: () => import("/usr/src/app/src/pages/registration/seminar/[...all].vue")
  },
  {
    name: "shop-checkout-order-id___de",
    path: "/shop/checkout/order/:id()",
    meta: indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue")
  },
  {
    name: "shop-checkout-order-id___en",
    path: "/en/shop/checkout/order/:id()",
    meta: indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue")
  },
  {
    name: "shop-checkout-order-id___fr",
    path: "/fr/shop/checkout/order/:id()",
    meta: indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue")
  },
  {
    name: "shop-checkout-order-id___it",
    path: "/it/shop/checkout/order/:id()",
    meta: indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue")
  }
]